/*
 * Copyright (c) 2020.
 * kurokeita
 */

import {
  APPROVAL_TELEGRAM_GROUP_LIST_SUCCESS,
  APPROVAL_TELEGRAM_GROUP_UPDATE_SUCCESS,
  APPROVAL_TELEGRAM_GROUP_DELETE_SUCCESS,
  APPROVAL_TELEGRAM_GROUP_CREATE_SUCCESS,
  APPROVAL_TELEGRAM_GROUP_DETAIL_SUCCESS,
  APPROVAL_TELEGRAM_GROUP_CREATE_ERROR,
  APPROVAL_TELEGRAM_GROUP_UPDATE_ERROR,
} from "../../../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const ApprovalTelegramReducer = (state = {}, action) => {
  if (action.payload === undefined || action.payload === false) return state;

  switch (action.type) {
    case APPROVAL_TELEGRAM_GROUP_LIST_SUCCESS:
      let telegramGroupList = action.payload.data.data;

      telegramGroupList.map((group) => {
        let id = group["id"];
        state[id] = group;
        return true;
      });

      return { ...state, action };

    case APPROVAL_TELEGRAM_GROUP_CREATE_SUCCESS:
    case APPROVAL_TELEGRAM_GROUP_UPDATE_SUCCESS:
    case APPROVAL_TELEGRAM_GROUP_DELETE_SUCCESS:
    case APPROVAL_TELEGRAM_GROUP_DETAIL_SUCCESS:
      let id = action.payload.data["id"];
      state[id] = action.payload.data;
      return { ...state, action };
    case APPROVAL_TELEGRAM_GROUP_CREATE_ERROR:
    case APPROVAL_TELEGRAM_GROUP_UPDATE_ERROR:
      return { ...state, action };
    default:
      return state;
  }
};

export { ApprovalTelegramReducer };
